export const FrameStyle = {
  DARK: 'border-neutral-950-opacity-60 text-neutral-100 bg-neutral-100-opacity-5',
  LIGHT: 'border-neutral-100-opacity-10 bg-primary-600-opacity-10 text-primary-600',
};

export interface FramesRendererProps {
  theme?: (typeof FrameStyle)[keyof typeof FrameStyle];
  data?: {
    panels: {
      id: string;
      width: number;
      height: number;
      count: number;
    }[];
  };
}
